/* eslint-disable max-len */
import EaDisplayAds from '@propertypal/shared/src/resources/icons/products/ea-display-ads-icon.svg';
import EaTakeover from '@propertypal/shared/src/resources/icons/products/ea-homepage-takeover-icon.svg';
import EaWebsite from '@propertypal/shared/src/resources/icons/products/ea-websites-icon.svg';
import EaWhyTraffic from '@propertypal/shared/src/resources/icons/products/why-traffic-icon.svg';
import DisplayAdsMockup from '@propertypal/shared/src/resources/images/display-ads/ea-display-ads-mockup.png';
import React from 'react';
import ProductsPageHeader, { ProcutsHeaderIcon } from '../headers/products/ProductsPageHeader';
import DisplayAdverts from './DisplayAdverts';
import ProductScreenTabs, { ProductScreenTab } from './ProductScreenTabs';

const icons: ProcutsHeaderIcon[] = [
  {
    SVG: EaTakeover,
    heading: '1.3 million',
    text: `active users monthly`,
    maxW: 200,
  },
  {
    SVG: EaWhyTraffic,
    heading: '5.75 million',
    text: `website sessions monthly`,
    maxW: 240,
  },
  {
    SVG: EaWebsite,
    heading: '155 million',
    text: `page views monthly`,
    maxW: 190,
  },
];

const tabs: ProductScreenTab[] = [
  {
    title: 'Adverts',
    text: `Range of adverts including leaderboard, skyscrapers and MPUs available`,
    maxW: 300,
  },
  {
    title: 'Traffic',
    text: `Campaigns are architected to follow the natural ebb and flow of visitor traffic to maximise your return on investment`,
    maxW: 300,
  },
  {
    title: 'Highly targeted',
    text: `Adverts are only visible for relevant searches to maximise impact e.g. properties for sale in Newtownards`,
    maxW: 265,
  },
];

const DisplayAdvertising: React.FC = () => {
  return (
    <>
      <ProductsPageHeader
        title="Display Advertising"
        text="Build your brand and extend your reach to an audience very specific to you"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 780 }}
        icon={<EaDisplayAds />}
        icons={icons}
        iconsColumnGap={110}
      />
      <ProductScreenTabs
        tabs={tabs}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        staticTabs
        breakpoint={1180}
        tabsMt={-15}
        mockup={DisplayAdsMockup}
      />
      <DisplayAdverts />
    </>
  );
};

export default DisplayAdvertising;
